import React, {Component}   from 'react';
import PropTypes            from 'prop-types';
import FieldError           from '../Fragments/FieldError';

let Quote = require('../Managers/Quote');
let Validation = require('../Managers/Validation.js');

class EmailInput extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isValid: (Quote.getCurrentAnswer(this.props.fieldName)) ? true : false,
            hasError: false,
            errors: null,
            isHelpVisible: false,
            email : null,
            activeValue: props.defaultValue ? props.defaultValue : null,
        };
    }

    componentWillMount() {
        if (this.props.defaultValue) {
            this.setState({isValid: true});
            this.props.isValid(true);
        }
    }

    handleValidation(value) {
        this.setActiveValue(value);
    }

    /**
     * Pass in the validation rule to apply against the user-provided value.
     *
     * @param value
     */
    setActiveValue(value) {
        try {
            // pass an options argument with "matchTo" of the DOM ID of the target we're
            // matching against
            let validation = Validation.validate(this.props.dataValidation, value, {
                matchTo: this.props.dataMatchTo
            })[0];

            this.setState(validation);
            this.setState({
                activeValue: value,
            }, () => {
                this.props.isValid(validation.isValid);
            });

            if (validation.isValid) {
                if (this.props.isValidCallbackFunction) {
                    this.props.isValidCallbackFunction(value);
                }
            } else {
                if (this.props.isInvalidCallbackFunction) {
                    this.props.isInvalidCallbackFunction(value);
                }
            }

            Quote.set(this.props.storageKey, value, this.props.source);
            Quote.setAnswer(this.props.storageKey, value);

            if (this.props.callbackFunction) {
                this.props.callbackFunction(value);
            }
        } catch (err) {
            this.setState({isValid: false, hasError: true, errors: [
                "Please enter a valid email address"
            ]}, () => {
                this.props.isValid(false);
            });
            if (this.props.isInvalidCallbackFunction) {
                this.props.isInvalidCallbackFunction(value);
            }
            if (this.props.callbackFunction) {
                this.props.callbackFunction(value);
            }
        }

        this.setState({ activeValue: value });
    }

    getCurrentValue() {
        return this.state.activeValue;
    }

    render() {
        return (
            <div className="question-input">
                <input
                    name={this.props.fieldName}
                    id={this.props.fieldName}
                    type="email"
                    className="form-control"
                    onBlur={(event) => { this.setActiveValue(event.target.value); }}
                    data-validation={this.props.dataValidation}
                    data-matchto={this.props.dataMatchTo}
                    defaultValue={this.props.defaultValue}
                />

                {this.state.hasError === true ?
                    <FieldError errors={this.state.errors} />
                :null}
            </div>
        );
    }
}

EmailInput.propTypes = {
    fieldName:                  PropTypes.string.isRequired,
    storageKey:                 PropTypes.string,
    helpText:                   PropTypes.string,
    question:                   PropTypes.string.isRequired,
    dataValidation:             PropTypes.string,
    dataMatchTo:                PropTypes.string,
    isValidCallbackFunction:    PropTypes.func,
    isInvalidCallbackFunction:  PropTypes.func,
    callbackFunction:           PropTypes.func,
    source:                     PropTypes.string,
    isValid:                    PropTypes.func,
    defaultValue:               PropTypes.string,
};

export default EmailInput;


// WEBPACK FOOTER //
// ./src/components/Fields/EmailInput.js